"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSkeleton = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const CardSkeleton = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Skeleton, { variant: "rectangular", width: 120, height: 120, sx: { borderRadius: '10px', flexShrink: 0 } }),
        react_1.default.createElement(material_1.Box, { sx: {
                flex: 1,
                ml: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            } },
            react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 } },
                react_1.default.createElement(material_1.Skeleton, { variant: "text", width: "30%", height: 30 }),
                react_1.default.createElement(material_1.Skeleton, { variant: "text", width: "40%", height: 40 })),
            react_1.default.createElement(material_1.Skeleton, { variant: "text", width: "70%", height: 40, sx: { mb: 1 } }),
            react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' } },
                react_1.default.createElement(material_1.Skeleton, { variant: "text", width: "200px", height: 30 }),
                react_1.default.createElement(material_1.Skeleton, { variant: "rectangular", width: 20, height: 20, sx: { borderRadius: '4px' } })))));
};
exports.CardSkeleton = CardSkeleton;
